import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectMedicalExpenseZurichStep = (state) => state.get('medicalExpenseZurichStep');

const makeSelectMedicalExpenseZurichStep = () => createSelector(
  selectMedicalExpenseZurichStep,
  (stepMedicalExpenseZurichState) => ({
    relationshipToYou: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'relationshipToYou']),
      ''
    ),
    nationalIdOrVisa: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'nationalIdOrVisa']),
      ''
    ),
    id: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'id']),
      ''
    ),
    purposeOfTrip: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'purposeOfTrip']),
      ''
    ),
    didYouContactAssistanceCompany: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'didYouContactAssistanceCompany']),
      ''
    ),
    ifOtherPleaseDescribe: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifOtherPleaseDescribe']),
      ''
    ),
    disYouContactAssistanceCompany: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'disYouContactAssistanceCompany']),
      ''
    ),
    assistanceCaseReferenceNumberFileNumber: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'assistanceCaseReferenceNumberFileNumber']),
      ''
    ),
    didYouHaveOtherMedicalInsurance: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'didYouHaveOtherMedicalInsurance']),
      ''
    ),
    insuranceCarriersName: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'insuranceCarriersName']),
      ''
    ),
    address: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'postalCode']),
      ''
    ),
    policyId: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'policyId']),
      ''
    ),
    policyHolder: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'policyHolder']),
      ''
    ),
    areYouACitizenOfTheEuropeanUnion: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'areYouACitizenOfTheEuropeanUnion']),
      ''
    ),
    forEUCitizens: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'forEUCitizens']),
      ''
    ),
    ifYesWasTheEHIC: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifYesWasTheEHIC']),
      ''
    ),
    ifNoPleaseExplain: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifNoPleaseExplain']),
      ''
    ),
    accidentStartDate: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'accidentStartDate']),
      ''
    ),
    accidentFirstTreatment: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'accidentFirstTreatment']),
      ''
    ),
    nameOfPhysicianFacilityFirstContacted: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'nameOfPhysicianFacilityFirstContacted']),
      ''
    ),
    addressForHospital: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'addressForHospital']),
      ''
    ),
    cityOrTownForHospital: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'cityOrTownForHospital']),
      ''
    ),
    countryForHospital: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'countryForHospital']),
      ''
    ),
    emailForHospital: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'emailForHospital']),
      ''
    ),
    phoneNumberForHospital: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'phoneNumberForHospital']),
      ''
    ),
    postalCodeForHospital: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'postalCodeForHospital']),
      ''
    ),
    isTheClaimTheResultOfAniLLness: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'isTheClaimTheResultOfAniLLness']),
      ''
    ),
    alternativeTreatment: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'alternativeTreatment']),
      ''
    ),
    accidentStartDateForIllness: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'accidentStartDateForIllness']),
      ''
    ),
    symptoms: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'symptoms']),
      ''
    ),
    detailsForIllness: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'detailsForIllness']),
      ''
    ),
    isTheClaimTheResultOfAccidentOrInjury: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'isTheClaimTheResultOfAccidentOrInjury']),
      ''
    ),
    place: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'place']),
      ''
    ),
    accidentDate: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'accidentDate']),
      ''
    ),
    accidentTime: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'accidentTime']),
      ''
    ),
    detailsForAccident: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'detailsForAccident']),
      ''
    ),
    wasTheAccidentOrInjuryTheResultOfPlayingASportODueToAHazardousActivity: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'wasTheAccidentOrInjuryTheResultOfPlayingASportODueToAHazardousActivity']),
      ''
    ),
    nameOfPhysicianFacilityFirstContactedForPhysician: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'nameOfPhysicianFacilityFirstContactedForPhysician']),
      ''
    ),
    addressForPhysician: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'addressForPhysician']),
      ''
    ),
    cityOrTownForPhysician: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'cityOrTownForPhysician']),
      ''
    ),
    countryForPhysician: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'countryForPhysician']),
      ''
    ),
    postalCodeForPhysician: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'postalCodeForPhysician']),
      ''
    ),
    phoneNumberForPhysician: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'phoneNumberForPhysician']),
      ''
    ),
    facilityName: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'facilityName']),
      ''
    ),
    addressForProvide: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'addressForProvide']),
      ''
    ),
    cityOrTownForProvide: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'cityOrTownForProvide']),
      ''
    ),
    countryForProvide: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'countryForProvide']),
      ''
    ),
    postalCodeForProvide: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'postalCodeForProvide']),
      ''
    ),
    phoneNumberForProvide: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'phoneNumberForProvide']),
      ''
    ),
    admitDate: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'admitDate']),
      ''
    ),
    timeOfAdmission: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'timeOfAdmission']),
      ''
    ),
    dischargeDate: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'dischargeDate']),
      ''
    ),
    timeOfDischarge: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'timeOfDischarge']),
      ''
    ),
    expensesClaimed: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'expensesClaimed']),
      ''
    ),
    currencyForProvide: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'currencyForProvide']),
      ''
    ),
    didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness']),
      ''
    ),
    wereYouTravelingToReceiveMedicalTreatment: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'wereYouTravelingToReceiveMedicalTreatment']),
      ''
    ),
    ifYesWhenDidYouLearnOfTheAlternativeTreatment: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifYesWhenDidYouLearnOfTheAlternativeTreatment']),
      ''
    ),
    whoRecommendedTheTreatment: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'whoRecommendedTheTreatment']),
      ''
    ),
    areYouPregnant: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'areYouPregnant']),
      ''
    ),
    ifYesNumberOfWeeks: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifYesNumberOfWeeks']),
      ''
    ),
    changeTo: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'changeTo']),
      ''
    ),
    ifYesNameOfPhysicianCurrentlyTreatingThis: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifYesNameOfPhysicianCurrentlyTreatingThis']),
      ''
    ),
    isTheClaimTheResultYes: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'isTheClaimTheResultYes']),
      ''
    ),
    ifYesForTheCollengiateSportsProgram: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifYesForTheCollengiateSportsProgram']),
      ''
    ),
    isTheClaimTheResultNo: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'isTheClaimTheResultNo']),
      ''
    ),
    wasAnyotherPersonResponsibleForCausingYourAccident: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'wasAnyotherPersonResponsibleForCausingYourAccident']),
      ''
    ),
    ifYesPleaseExplain: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifYesPleaseExplain']),
      ''
    ),
    wereYouUnderTheInfluenceOfDrugsOrAlclholAtTheTimeOfTheAcctident: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'wereYouUnderTheInfluenceOfDrugsOrAlclholAtTheTimeOfTheAcctident']),
      ''
    ),
    wasTheAccidentOrInjuryTheResultOfAHazardousActivity: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'wasTheAccidentOrInjuryTheResultOfAHazardousActivity']),
      ''
    ),
    ifYesPleaseExplainOfAHazardousActivity: mapWithDefault(
      stepMedicalExpenseZurichState,
      () => stepMedicalExpenseZurichState.getIn(['form', 'ifYesPleaseExplainOfAHazardousActivity']),
      ''
    ),
    prescriptionMedicinesNotInjury: mapWithDefault(stepMedicalExpenseZurichState, () => stepMedicalExpenseZurichState.getIn(['form', 'prescriptionMedicinesNotInjury']) && stepMedicalExpenseZurichState.getIn(['form', 'prescriptionMedicinesNotInjury']).toJS(), ''),
    prescriptionMedicinesForInjury: mapWithDefault(stepMedicalExpenseZurichState, () => stepMedicalExpenseZurichState.getIn(['form', 'prescriptionMedicinesForInjury']) && stepMedicalExpenseZurichState.getIn(['form', 'prescriptionMedicinesForInjury']).toJS(), ''),
  })
);

const makeSelectMedicalExpenseZurichStepErrors = () =>
  createSelector(selectMedicalExpenseZurichStep, (state) => state.get('errors'));

export {
  makeSelectMedicalExpenseZurichStep,
  makeSelectMedicalExpenseZurichStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Zurich.MedicalExpense/selectors.js